import { Theme } from '@mui/material'
import { ApexOptions } from 'apexcharts'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { GroupByDate } from 'graphql/generated-types'

import { ChartHelpers } from '@/utils/chart.helpers'

dayjs.extend(utc)

export const getDefaultOverTimeLineChartOptions = (
  theme: Theme,
  title: string,
  t: (key: string) => string,
  granularity: GroupByDate,
  series?: ApexOptions['series'],
  dates?: number[],
  loading?: boolean,
  isMobile?: boolean,
): ApexOptions => {
  const maxTicks = isMobile ? 5 : 10

  return {
    chart: {
      id: title,
      zoom: {
        allowMouseWheelZoom: false,
      },
      toolbar: {
        tools: {
          download: false,
        },
      },
    },
    theme: {
      mode: theme.palette.mode,
    },
    dataLabels: { enabled: false },
    stroke: {
      width: 5,
      curve: 'straight',
      dashArray: 0,
    },
    markers: { size: 0 },
    xaxis: {
      type: 'category',
      categories: dates?.map(date =>
        dayjs
          .utc(date)
          .format(ChartHelpers.getShortDateFormatFromGroupBy(granularity)),
      ),
      labels: {
        rotate: 0,
        hideOverlappingLabels: true,
        showDuplicates: false,
        maxHeight: 50,
      },
      tickAmount: Math.min(Math.max((dates?.length || 0) - 1, 0), maxTicks),
      tickPlacement: 'on',
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      labels: {
        minWidth: 40,
      },
    },
    tooltip: {
      shared: true,
      y: series?.map(() => ({
        title: {
          formatter(val: string) {
            return val
          },
        },
      })),
    },
    colors: [
      theme.palette.primary.light,
      theme.palette.success.light,
      theme.palette.warning.light,
      theme.palette.info.light,
      theme.palette.error.light,
      theme.palette.info.dark,
    ],
    noData: {
      text: loading ? t('common.loadingDots') : t('chartDefaults.noData'),
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        color: '#000000',
        fontSize: '28px',
        fontFamily: 'Inter',
      },
    },
  }
}
